<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Add Account</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      <div class="flex-container header">
        <div class="form-section-heading">Details</div>
      </div>
      <div class="flex-container">
        <mat-form-field class="flex-half">
          <mat-label>Name</mat-label>
          <input
            matInput
            autocomplete="off"
            type="text"
            formControlName="name"
            required
            id="0101013e-0f46-41ed-b691-ae80c5d402f1"
            />
            @if (form.get('name')?.hasError('required')) {
              <mat-error> Name is Required. </mat-error>
            }
            @if (form.get('name')?.hasError('pattern') || form.get('name')?.hasError('noContent')) {
              <mat-error>
                Name must contain characters.
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="flex-half">
            <mat-label>Company Code</mat-label>
            <input
              matInput
              autocomplete="off"
              type="text"
              formControlName="shortName"
              required
              id="da3f4117-6f13-430f-9562-b5567bdb5a28"
              />
              @if (form.get('shortName')?.hasError('required')) {
                <mat-error> Company Code is Required. </mat-error>
              }
              @if (form?.get('shortName')?.hasError('pattern')) {
                <mat-error
                  >Company Code can only contain lower case alphabetic characters and numbers.</mat-error
                  >
              }
              @if (form?.get('shortName')?.hasError('maxlength')) {
                <mat-error
                  >Company Code must be less than 50 characters</mat-error
                  >
                }
              </mat-form-field>
            </div>
            <mat-form-field class="flex-half">
              <mat-label>Time Zone</mat-label>
              <input
                [lcsSingleSelect]="timeZoneSelect"
                ndtTimeZoneSelect
                autocomplete="off"
                type="text"
                formControlName="timeZoneId"
                id="77438b1f-71d2-48d1-90a6-5d3a5b43257f"
                required
                />
                <ndt-time-zone-select #timeZoneSelect></ndt-time-zone-select>
                @if (form.get('timeZoneId')?.hasError('required')) {
                  <mat-error> Time Zone Field is Required. </mat-error>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>LCS Account #</mat-label>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  formControlName="lcsAccountNumber"
                  id="a914d0f0-a0cb-4b74-8d76-ce50d094ce88"
                  />
                  @if (form.get('lcsAccountNumber')?.hasError('pattern')) {
                    <mat-error> Must be a number. </mat-error>
                  }
                  @if (form.get('lcsAccountNumber')?.hasError('max')) {
                    <mat-error>Must be less than 11 digits</mat-error>
                  }
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Line Limit</mat-label>
                  <input
                    matInput
                    autocomplete="off"
                    type="number"
                    formControlName="pstnLineLimit"
                    id="192d7de1-61b6-414f-b80f-902a300f94e8"
                    required
                    />
                    @if (form.get('pstnLineLimit')?.hasError('required')) {
                      <mat-error> Line Limit is Required. </mat-error>
                    }
                    @if (form.get('pstnLineLimit')?.hasError('min')) {
                      <mat-error>
                        Line Limit must be greater than 0.
                      </mat-error>
                    }
                    @if (form.get('pstnLineLimit')?.hasError('pattern')) {
                      <mat-error>
                        Line Limit must be an integer
                      </mat-error>
                    }
                    @if (form.get('pstnLineLimit')?.hasError('max')) {
                      <mat-error>
                        Line Limit must be less than 1000
                      </mat-error>
                    }
                  </mat-form-field>

                  <h4 class="account-header-margin">Account Status</h4>
                  <mat-checkbox matInput formControlName="isResidential" id="f2f48dcf-837e-49a6-a04d-377bab490d11"
                    >Residential</mat-checkbox
                    >

                    <h4 class="header-margin">Recording Options</h4>
                    <mat-checkbox
                      class="add-account-checkbox"
                      matInput
                      formControlName="isRecordInboundCalls"
                      id="5060060b-569c-48e4-aa34-e0bf5cf3bdc4"
                      >Inbound Calls</mat-checkbox
                      >
                      <mat-checkbox
                        class="add-account-checkbox"
                        matInput
                        formControlName="isRecordOutboundCalls"
                        id="f6174c4a-83ba-4ffe-b405-71e09beaa8ac"
                        >Outbound Calls</mat-checkbox
                        >
                        <mat-checkbox
                          class="add-account-checkbox"
                          matInput
                          formControlName="isRecordInternalCalls"
                          id="d212e611-8aeb-45c5-b466-001f7e5e868f"
                          >Internal Calls</mat-checkbox
                          >
                          <mat-checkbox
                            class="flex-full"
                            matInput
                            formControlName="isOtrEnabled"
                            >One-Touch Recording</mat-checkbox
                            >
                            <mat-form-field>
                              <mat-label>Active Start Date *</mat-label>
                              <input
                                matInput
                                autocomplete="off"
                                lcsDatepicker
                                formControlName="activeStartDate"
                                required
                                [lcsDatepickerPanel]="activeStartDatePanel"
                                id="909b6d3a-26a3-4ec2-8921-8021411bb56e"
                                />
                                <lcs-datepicker-toggle matSuffix [for]="activeStartDatePanel"></lcs-datepicker-toggle>
                                <lcs-datepicker-panel #activeStartDatePanel></lcs-datepicker-panel>
                                @if (form.get('activeStartDate')?.hasError('required')) {
                                  <mat-error>
                                    Active Start Date is Required.
                                  </mat-error>
                                }
                              </mat-form-field>
                              <ng-container>
                                <div class="flex-container header">
                                  <div class="form-section-heading">Location Information</div>
                                  <button type="button" mat-stroked-button color="primary" (click)="addLocationClick()"
                                    >Add Location</button
                                    >
                                  </div>
                                  <ndt-account-locations
                                    (onEditClicked)="editLocationClick($event)"
                                    formControlName="newAccountLocations"
                                  ></ndt-account-locations>
                                </ng-container>
                                <ng-container>
                                  <div class="flex-container header">
                                    <div class="form-section-heading">Extensions</div>

                                    <button type="button" mat-stroked-button color="primary" [matMenuTriggerFor]="createExtensionMenu"
                                      >Add Extension</button
                                      >
                                      <mat-menu #createExtensionMenu="matMenu">
                                        @for (createExtensionTypeOption of createExtensionTypeOptions; track createExtensionTypeOption) {
                                          <button
                                            mat-menu-item
                                            (click)="addExtensionClick(createExtensionTypeOption)"
                                            >{{ createExtensionTypeOption?.displayName }}</button
                                            >
                                        }
                                      </mat-menu>
                                    </div>
                                    <ndt-account-extensions
                                      (onEditClicked)="onEditClicked($event)"
                                      (removeExtension)="onRemoveExtension($event)"
                                      formControlName="newExtensions"
                                    ></ndt-account-extensions>
                                  </ng-container>
                                  <ng-container>
                                    <div class="flex-container header">
                                      <div class="form-section-heading">Phone Numbers</div>
                                      <button type="button" mat-stroked-button color="primary" [matMenuTriggerFor]="addPhoneNumberMenu"
                                        >Add Phone Number</button
                                        >
                                        <mat-menu #addPhoneNumberMenu="matMenu">
                                          <button mat-menu-item (click)="addPhoneNumberClick(false)">Add Existing Phone Number</button>
                                          <button mat-menu-item (click)="addPhoneNumberClick(true)">Add New Phone Number</button>
                                        </mat-menu>
                                      </div>
                                      <ndt-account-phone-numbers formControlName="newPhoneNumbers"></ndt-account-phone-numbers>
                                    </ng-container>
                                  </mat-dialog-content>
                                  <mat-dialog-actions>
                                    <button type="submit" title="Create" mat-raised-button id="e79cc07e-02a4-4f1e-9d29-711ac67f3b04">Save</button>
                                  </mat-dialog-actions>
                                </form>
                              </lcs-loading-overlay>
